// Form 2290's "prior period" - the filing period one year before the return
// currently being filed. TY2026's return covers July 2026-June 2027, so the
// prior period is July 2025-June 2026. Shared by every wizard step that asks
// about something that happened on/under the vehicle's PRIOR Form 2290
// (Credits' Line 5 disposal date, Prior Year's Line 9 transfer date) - both
// concern the same period, per i2290 p.7 ("If in the prior period, Form
// 2290, line 7, was completed and the tax-suspended vehicles were sold or
// otherwise transferred, complete line 9") and matches the backend's
// PRIOR_SEASON_START (VehicleTaxCalculationServiceImpl).
export const PRIOR_PERIOD_START = "2025-07";
export const PRIOR_PERIOD_END = "2026-06-30";
export const PRIOR_PERIOD_MIN_DATE = `${PRIOR_PERIOD_START}-01`;
export const PRIOR_PERIOD_HINT = "On the vehicle's prior return: July 2025 - June 2026.";
